import { connect } from 'react-redux'
import { notified } from 'store/ducks/messaging'
import Notification from './presentational'

const mapStateToProps = (state, props) => {
  return {
    unreadMessages: state.messenger.unread_messages,
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  notify: (unreadMessage) => dispatch(notified(unreadMessage)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Notification)
